import * as React from 'react';
import './TabWrap.scss';
import Tab from '@src/components/tabs/tab/Tab';

export interface ITab {
    title: string;
    isActive: boolean;
}
export interface IProps {
    tabs: ITab[];
}

export interface IFunctions {
    onTabClick: (index: number) => void;
}

export type IAllProps = IProps & IFunctions;

export const TabWrap: React.SFC<IAllProps> = ({ tabs, onTabClick }) =>
    <ul className="TabWrap-wrap">
        {tabs.map((tab, index) =>
            <Tab
                key={tab.title}
                title={tab.title}
                isActive={tab.isActive}
                onClick={() => onTabClick(index)}
            />,
        )}
    </ul>;

export default TabWrap;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/tabs/tab-wrap/TabWrap.tsx